import ParseHtml from '@/lib/utils/parse-html'

export default function CustomHtml({
  html,
  fullWidth = false,
}: {
  html: string
  fullWidth?: boolean
}) {
  return (
    <div className="component component--custom-script">
      {fullWidth ? (
        <ParseHtml html={html} />
      ) : (
        <div className="container">
          <ParseHtml html={html} />
        </div>
      )}
    </div>
  )
}
